import { FC } from 'react';
import SectionHeader from '@/statistics/templates/eie/components/SectionHeader';
import Card from '@mui/material/Card';
import { IGoogleStatsModel } from '@/shared/models/advertisements/statistics/google-stats.model';

interface IGoogleStatisticsProps {
  googleStats: IGoogleStatsModel | null;
}

export const GoogleStatistics: FC<IGoogleStatisticsProps> = ({ googleStats }) => {
  return (
    <>
      <Card sx={{ width: '100%' }}>
        <SectionHeader
          platform="Google"
          totalClicks={googleStats?.totalClicks ?? 0}
          totalImpressions={googleStats?.totalImpressions ?? 0}
        />
      </Card>
    </>
  );
};
